import { FC } from 'react';
import { styled } from '@mui/material/styles';

const PanesRoot = styled('div', {
  name: 'O2Panes',
  slot: 'Root',
})(() => ({
  '& > .MuiPaper-root': {
    '&:not(:first-of-type)': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    '&:not(:last-of-type)': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
}));

/**
 * Connects more panes to one group.
 * @deprecated Use `@o2/ui/MultiPaper` instead.
 */
const Panes: FC = (props) => {
  return <PanesRoot>{props.children}</PanesRoot>;
};

export default Panes;
